import { render, staticRenderFns } from "./OrganizationStorageBox.vue?vue&type=template&id=44becc12&scoped=true&"
import script from "./OrganizationStorageBox.vue?vue&type=script&lang=js&"
export * from "./OrganizationStorageBox.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationStorageBox.vue?vue&type=style&index=0&id=44becc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44becc12",
  null
  
)

export default component.exports